module.exports = __webpack_public_path__ + "assets/img/lime_team.1401ae79.png";